module.exports = __webpack_public_path__ + "img/messenger.4e246f24.svg";